import { css } from 'aphrodite';
import * as React from 'react';
import * as queryString from 'query-string';

import * as LoginErrorMessageUtils from 'login-utils/loginErrorMessageUtils';
import * as LoginUtils from 'login-utils/loginUtils';
import LoginForm from '../Login/LoginForm/LoginForm';
import PrimaryButton from '../Common/Buttons/PrimaryButton';
import { paneFormStyles } from '../Common/PaneLayout/paneStyles';
import LogoutDialog from './LogoutDialog/LogoutDialog';

interface QueryProps {
  loginMethod: string;
  message: string;
}

class Logout extends React.Component<ReactRouter.RouteComponentProps<{}, {}>, {}> {
  render() {
    const { location } = this.props;
    const queryProps = queryString.parse(location.search) as QueryProps;
    const loginLink = LoginUtils.getLoginUrl(queryProps.loginMethod);
    const serverMessage = LoginErrorMessageUtils.generate(queryProps.message);

    if (queryProps.loginMethod === 'email') {
      return (
        <div className="Logout">
          {serverMessage && <LogoutDialog errorMessage={serverMessage.message} />}
          <LoginForm />
        </div>
      );
    }
    return (
      <div className={css(paneFormStyles.container)} data-it="Logout">
        <p>You can sign on to your online loan application by clicking the button below.</p>
        <div className={css(paneFormStyles.buttonDisplay, paneFormStyles.buttonPadding)}>
          <a href={loginLink} className={css(paneFormStyles.contextLink)} data-it="Logout-actionLink">
            <PrimaryButton wide text="Sign on" />
          </a>
        </div>
      </div>
    );
  }
}

export default Logout;
